import {actions as A} from '../constants/actions';

export const setPage = page => dispatch => {
  dispatch({
    type: A.SET_PAGE,
    payload: {page}
  });
};
